import { Chip, Tooltip } from "@mui/material";
import { tagsColors } from "constants/colors";

import type { IWorkTitleTag } from "../types";

export const TITLE_TAG_DISPLAY_LIMIT = 3;

type WorkTitleTagsProps = {
    tags?: IWorkTitleTag[];
    className?: string;
};

const WorkTitleTags = ({ tags, className }: WorkTitleTagsProps) => {
    if (!tags?.length) return null;

    const visibleTags = tags.slice(0, TITLE_TAG_DISPLAY_LIMIT);
    const extraTags = tags.slice(TITLE_TAG_DISPLAY_LIMIT);

    return (
        <span className={className}>
            {visibleTags.map((tag) => {
                const tagColor = tagsColors.find((item) => item.id === tag.color) ?? tagsColors[0];
                return (
                    <Chip
                        key={tag.id}
                        component="span"
                        size="small"
                        label={tag.name}
                        sx={{
                            height: 20,
                            maxWidth: "100%",
                            fontSize: 11,
                            fontFamily: "Poppins, sans-serif",
                            backgroundColor: tagColor.backgroundColor,
                            color: tagColor.textColor,
                            "& .MuiChip-label": {
                                padding: "0 8px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            },
                        }}
                    />
                );
            })}
            {extraTags.length > 0 && (
                <Tooltip title={extraTags.map((tag) => tag.name).join(", ")} arrow>
                    <Chip
                        component="span"
                        size="small"
                        label={`+${extraTags.length}`}
                        sx={{
                            height: 20,
                            fontSize: 11,
                            fontFamily: "Poppins, sans-serif",
                            backgroundColor: "#f0f0f0",
                            color: "#646464",
                            "& .MuiChip-label": {
                                padding: "0 6px",
                            },
                        }}
                    />
                </Tooltip>
            )}
        </span>
    );
};

export default WorkTitleTags;
